import { schAlertType } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import { calcSiteToValueRatios } from '../utils/calcSiteToValueRatios.ts';
import { getDepreciatedCostPageRoute } from '../utils/getDepreciatedCostPageRoute.ts';

const RANGE_THRESHOLD = 0.2;
const formatRatio = (ratio: number) => (ratio * 100).toFixed(1);

export const limitedSiteToValueRatioRange: AlertDefinition = (params) => {
  if (params.compSequence.length < 2) return undefined;

  const siteToValueRatios = calcSiteToValueRatios(params);
  if (!siteToValueRatios) return undefined;

  const { minCompRatio, maxCompRatio } = siteToValueRatios;
  if (maxCompRatio - minCompRatio <= RANGE_THRESHOLD) return undefined;

  return {
    type: schAlertType.enum.limitedSiteToValueRatioRange,
    status: 'active',
    severity: 'error',
    message: `The range of Site to Value Ratios across Comparables exceeds ${formatRatio(RANGE_THRESHOLD)}% (${formatRatio(minCompRatio)}% - ${formatRatio(maxCompRatio)}%).`,
    fixingInfo: {
      tips: 'Tips: Ranges should be relatively tight to ensure the Comparables compete in the same market segment. This ensures adjustments are statistically reliable, and suggest the selected properties are truly comparable. If a Comparable has a significantly superior or inferior view, location, or lot size, then one or more of those factors could widen the range and should be commented on.',
      pairedCostRouteItem: getDepreciatedCostPageRoute(params.order),
      fixingMethod: ['comment', 'action'],
      commentAlwaysRequired: false,
    },
    triggers: [],
  };
};
